import LinkIcon from "@plone/volto/icons/link.svg";
import HomeIcon from "@plone/volto/icons/home.svg";
import FolderIcon from "@plone/volto/icons/folder.svg";
import UserIcon from "@plone/volto/icons/user.svg";
import PencilIcon from "@plone/volto/icons/pencil.svg";
import BriefcaseIcon from "@plone/volto/icons/briefcase.svg";
import FingerPrintIcon from "@plone/volto/icons/finger-print.svg";
import BellIcon from "@plone/volto/icons/bell-ringing.svg";
import VideoIcon from "@plone/volto/icons/videocamera.svg";
import AudioIcon from "@plone/volto/icons/audio.svg";
import CashIcon from "./icons/cash.svg";
import ClientNoteIcon from "./icons/client-note.svg";
import EconomyIcon from "./icons/economy.svg";
import GlobalMarketIcon from "./icons/global-market.svg";
import GoalIcon from "./icons/goal.svg";
import MacroReviewIcon from "./icons/macro-review.svg";
import ParliamentIcon from "./icons/parliament.svg";
import MapIcon from "./icons/quarter-circle-map.svg";
import RecessionIcon from "./icons/recession.svg";
import RiskAlertIcon from "./icons/risk-alert.svg";
import StrategicIntelligenceIcon from "./icons/strategic-intelligence.svg";
import SurveyIcon from "./icons/survey.svg";
import TeamIcon from "./icons/team.svg";
import WhatsappIcon from "./icons/whatsapp.svg";
import CompassIcon from "./icons/compass.svg";

// Exported so Edit/View can reuse without redefining
export const iconChoices = {
  cash: CashIcon,
  economy: EconomyIcon,
  market: GlobalMarketIcon,
  goal: GoalIcon,
  parliament: ParliamentIcon,
  map: MapIcon,
  recession: RecessionIcon,
  team: TeamIcon,
  RiskAlert: RiskAlertIcon,
  StrategicIntelligence: StrategicIntelligenceIcon,
  Survey: SurveyIcon,
  MacroReview: MacroReviewIcon,
  ClientNote: ClientNoteIcon,
  link: LinkIcon,
  home: HomeIcon,
  folder: FolderIcon,
  user: UserIcon,
  pencil: PencilIcon,
  briefcase: BriefcaseIcon,
  fingerprint: FingerPrintIcon,
  bell: BellIcon,
  video: VideoIcon,
  audio: AudioIcon,
  whatsapp: WhatsappIcon,
  compass: CompassIcon,
};

const schema = () => ({
  title: "Icon Link Row",
  fieldsets: [
    {
      id: "default",
      title: "Default",
      fields: [
        "header",
        "items",
        "buttonLabel",
        "buttonLink",
        "showButton",
        "mobileCarousel",
      ],
    },
  ],
  properties: {
    header: {
      title: "Header",
      type: "string",
    },
    items: {
      title: "Links",
      widget: "object_list",
      default: [
        {
          icon: "link",
          text: "Link",
          href: "",
        },
      ],
      schema: {
        title: "Link",
        fieldsets: [
          {
            id: "default",
            title: "Default",
            fields: ["itemHeader", "icon", "text", "href"],
          },
        ],
        properties: {
          itemHeader: {
            title: "Heading",
            type: "string",
          },
          icon: {
            title: "Icon",
            type: "string",
            default: "link",
            choices: Object.keys(iconChoices).map((key) => [key, key]),
          },
          text: {
            title: "Label",
            type: "string",
            default: "Link",
          },
          href: {
            title: "Link",
            widget: "object_browser",
            mode: "link",
            allowExternals: true,
          },
        },
        required: [],
      },
    },
    buttonLabel: {
      title: "Button text",
      type: "string",
    },
    buttonLink: {
      title: "Button link",
      widget: "object_browser",
      mode: "link",
      allowExternals: true,
    },
    showButton: {
      title: "Always show button",
      type: "boolean",
      default: false,
    },
    mobileCarousel: {
      title: "Use carousel on mobile",
      type: "boolean",
      default: false,
      description:
        "On small screens this row becomes a carousel with dots, one item per slide, and automatic scrolling.",
    },
  },
  required: [],
});

export default schema;
